<template>
  <van-card
    :price="productInfo.price[0]+'起'"
    :title="productInfo.name"
    @click="detail(productInfo)"
    >
        <template #tags>
            <p class="desc">
               {{productInfo.intro}}
            </p>
            <van-tag class="tag red">{{productInfo.company_simple_str}}</van-tag>
        </template>
  </van-card>
</template>

<script>
export default {
    props:["productInfo"],
    methods:{
        detail(info){
            console.log(info)
            // pjh
            this.$router.push("/productDetails?id="+info.id)
            // if(info.is_report==0){   //未报备
            //     this.$router.push("/productDetails?id="+info.id)
            // }else if(info.is_report==1){  //已报备
            //     // window.location.href=info.out_insure_url;
            //     window.open(info.out_insure_url);
            // }
        }
    },
}
</script>

<style scoped>
    .van-card{  
        
        box-sizing: border-box;
        box-shadow: 0px -1px 5px 1px rgba(0,0,0,0.08); 
        border-radius: 6px;
        margin:6px 16px;
        padding: 4px 10px 12px 10px;
        background: rgba(255,255,255,1);
    }
    .van-card__title{
        font-weight: 700;
        color: #333;
        font-size: 14px;
        padding-top: 4px;
    }
    .van-card__price{
        color:#F34740;
        font-size:11px;
    }
    .van-card__price-integer{
        font-size: 20px;
        font-weight:bold;
    }
    .van-card__thumb{
        width: 130px;
        height: 130px;
    }
    .van-card__content{
        padding-top: 2px;
    }
    .van-card__thumb /deep/ img{
        border-radius: 4px;
    }
    .van-card__bottom{
        line-height: 14px;
        margin-top: 13px;
    }
    .desc{
        color: #666666;
        font-size: 12px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        /* autoprefixer: on */
        -webkit-line-clamp: 2;  
        /*! autoprefixer: off */
        -webkit-box-orient: vertical;
        margin:0;
    }
    .tag{
        background: rgba(243,71,64,0.1);
        border-radius: 4px;
        padding: 0 5px 2px 5px;
        font-size:10px;
        font-weight: 500;
    }
</style>


// WEBPACK FOOTER //
// src/components/cellList2.vue